import { PersonCoreBase } from "./person.core.base"


export class PersonCore extends PersonCoreBase {

}